export default __webpack_public_path__ + "static/media/delete.51e79da2.svg";